import React from "react";

interface SignatureSectionProps {
  signature: string;
  signedDate: string;
}

export const SignatureSection: React.FC<SignatureSectionProps> = ({ signature, signedDate }) => {
  if (!signature) return null;

  return (
    <div className="bg-white rounded-lg p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">
        Customer Signature
      </h3>
      <div className="border-2 border-gray-300 rounded-lg p-4 bg-gray-50">
        <img
          src={signature}
          alt="Customer Signature"
          className="max-h-32 mx-auto"
        />
      </div>
      <p className="text-xs text-gray-500 text-center mt-2">
        Signed on {signedDate}
      </p>
    </div>
  );
};
